export default {
  PNG: "image/png",
  JPG: "image/jpg",
  JPEG: "image/jpeg",
};
